import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {User} from 'app/models/user.model';
import {DossierInterventionService} from 'app/services/dossier_intervention.service';
import {HttpErrorResponse} from '@angular/common/http';
import {FuseConfirmationService} from '@fuse/services/confirmation';
import {UserService} from 'app/core/user/user.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-dossier-v2',
    templateUrl: './dossier-v2.component.html',
    styleUrls: ['./dossier-v2.component.scss']
})
export class DossierV2Component implements OnInit {

    @Input() currentDossierIntervention: DossierIntervention = new DossierIntervention();
    @Input() users: User[] = [];
    @Output() submitEvent = new EventEmitter();
    @Output() valueChanged = new EventEmitter();
    errors: string[] = [];
    success: boolean = false;
    error: boolean = false;
    noDossierDejaUtiliser: boolean = false;
    technicienAllSelected: boolean = false;
    areAllTechnicienSelected: boolean = false;

    dossierInterventionForm: FormGroup;

    constructor(
        private dossierInterventionService: DossierInterventionService,
        private _userService: UserService,
        private fuseConfirmationService: FuseConfirmationService,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        const usersId = [];
        if (this.currentDossierIntervention.users != undefined && this.currentDossierIntervention.users.length > 0) {
            for (const user of this.currentDossierIntervention.users) {
                usersId.push(user.id);
            }
        }
        this.dossierInterventionForm = new FormGroup({
            no_dossier: new FormControl(this.currentDossierIntervention.no_dossier, [Validators.required]),
            compagnie_assurance: new FormControl(this.currentDossierIntervention.compagnie_assurance),
            nom_assure: new FormControl(this.currentDossierIntervention.nom_assure),
            date_perte: new FormControl(this.currentDossierIntervention.date_perte),
            adresse_propriete_endommagee: new FormControl(this.currentDossierIntervention.adresse_propriete_endommagee),
            personne_contact: new FormControl(this.currentDossierIntervention.personne_contact),
            commentaires: new FormControl(this.currentDossierIntervention.commentaires),
            date_rendez_vous: new FormControl(this.currentDossierIntervention.date_rendez_vous),
            activer: new FormControl(this.currentDossierIntervention.activer),
            users_id: new FormControl(usersId),
            expert_name: new FormControl(this.currentDossierIntervention.expert_name),
            phone1: new FormControl(this.currentDossierIntervention.phone1),
            phone2: new FormControl(this.currentDossierIntervention.phone2),
            email: new FormControl(this.currentDossierIntervention.email),
            mandat: new FormControl(this.currentDossierIntervention.mandat),
        });

        this.dossierInterventionForm.valueChanges.subscribe(() => {
            this.valueChanged.emit(true);
        });
    }

    setForm() {
        if (this.currentDossierIntervention != null) {
            const usersId = [];
            if (this.currentDossierIntervention.users != undefined && this.currentDossierIntervention.users.length > 0) {
                for (const user of this.currentDossierIntervention.users) {
                    usersId.push(user.id);
                }
            }
            this.dossierInterventionForm.patchValue({
                no_dossier: this.currentDossierIntervention.no_dossier,
                compagnie_assurance: this.currentDossierIntervention.compagnie_assurance,
                nom_assure: this.currentDossierIntervention.nom_assure,
                date_perte: this.currentDossierIntervention.date_perte,
                adresse_propriete_endommagee: this.currentDossierIntervention.adresse_propriete_endommagee,
                personne_contact: this.currentDossierIntervention.personne_contact,
                commentaires: this.currentDossierIntervention.commentaires,
                date_rendez_vous: this.currentDossierIntervention.date_rendez_vous,
                activer: this.currentDossierIntervention.activer,
                users_id: usersId,
            });
        }
    }

    get f() {
        return this.dossierInterventionForm?.controls;
    }

    onFormSubmit() {
        this.error = false;
        this.noDossierDejaUtiliser = false;
        this.success = false;
        this.dossierInterventionForm.markAllAsTouched();

        if (this.dossierInterventionForm.valid) {
            const dossierIntervention = new DossierIntervention(this.dossierInterventionForm.value);
            if (this.currentDossierIntervention.id != 0) {
                this.dossierInterventionService.update(dossierIntervention, this.currentDossierIntervention.id).subscribe(
                    (response) => {
                        this.success = true;
                        this.submitEvent.emit(response['id']);
                        this.valueChanged.emit(false);
                    }, (error) => {
                        if (error.status == 422) {
                            this.noDossierDejaUtiliser = true;
                        } else {
                            this.error = true;

                        }
                        this.showErrors(error);
                    }
                );
            } else {
                this.dossierInterventionService.store(dossierIntervention).subscribe(
                    (response) => {
                        this.success = true;
                        this.submitEvent.emit(response['id']);
                        this.valueChanged.emit(false);
                    }, (error) => {
                        if (error.status == 422) {
                            this.noDossierDejaUtiliser = true;
                        } else {
                            this.error = true;

                        }
                        this.showErrors(error);
                    }
                );
            }
        }
    }

    delete(id: number): void {
        if (this.isAdmin) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Suppression d\'un dossier d\'intervention',
                message: 'Êtes-vous certain de vouloir supprimer ce dossier d\'intervention',
                actions: {
                    confirm: {
                        label: 'Supprimer'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.dossierInterventionService.delete(id).subscribe(
                        (response) => {
                            this.router.navigate(['/dossiers-interventions']);
                            this.submitEvent.emit(response['id']);
                        },
                        (error) => {
                            console.log(error);
                            this.showErrors(error);
                        });
                }
            });
        }
    }

    get isAdmin(): boolean {
        return this._userService.getCurrentUser().role_id == 1;
    }

    showErrors(error: any) {
        //Gestion des erreurs laravel
        if (error instanceof HttpErrorResponse) {
            for (const key in error.error.errors) {
                //Todo: handle error
            }
        } else {
            error.forEach((element) => {
                //this.toastr.error(element);
            });
        }
    }

    toggleSelectAll(event: MouseEvent) {
        if (this.areAllTechnicienSelected) {
            this.dossierInterventionForm.get('users_id')?.setValue([]);
        } else {
            this.dossierInterventionForm.get('users_id')?.setValue(this.users.map(user => user.id));
        }
        this.areAllTechnicienSelected = !this.areAllTechnicienSelected;
    }
    
    isIndeterminate(): boolean {
        const selectedValues = this.dossierInterventionForm.get('users_id')?.value || [];
        return selectedValues.length > 0 && !this.areAllTechnicienSelected;
    }
}
